module.exports = __webpack_public_path__ + "static/gnb-2d2806e5fda3fb062b05fbdd8b0105a7.mp4";